import { Grid } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Box } from "@mui/system";
import { clearAllFilters, clearSelectedFilters } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { accessTypes } from "utils/CommonConstants";
import { triggerOnboadingWizard } from "utils/CommonFunctions";
import Button from "../../../../common/Button";
import { Hall } from "../Hall";
import "./Cards.scss";

interface ICard {
  label1: string;
  label2: string;
  list: Hall[];
}

const cardContentStyling = {
  marginBottom: "49px",
  padding: "0",
  gap: "20px",
  height: "auto"
};

export default function Cards(props: ICard) {
  const navigate = useNavigate();
  const { list } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const { isAbovePropertyUser } = useAppSelector((state) => state.app);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  const cardActionStyling = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: isMobileScreen ? "space-evenly" : "center",
    margin: "72px 0 0",
    padding: isMobileScreen ? "0px" : "8px"
  };

  const dispatch = useAppDispatch();

  return (
    <Card
      className="card"
      sx={{
        backgroundColor: tokens.Background.General.Primary,
        marginLeft: isMobileScreen ? "-15px" : "-32px",
        marginRight: isMobileScreen ? "-15px" : "-32px",
        height: "auto",
        padding: isMobileScreen ? "25px 16px" : "75px 16px"
      }}
    >
      <CardContent sx={cardContentStyling}>
        <Box display={"flex"} justifyContent="center" gap={1}>
          <Typography variant="h4">{props.label1}</Typography>
          <Typography variant="h4" showBold>
            {props.label2}
          </Typography>
        </Box>

        <CardActions sx={cardActionStyling}>
          {list?.map((element) => {
            return (
              <Box
                sx={{
                  background: element.theme.bgColor,
                  minHeight: { xs: "116px", md: "150px" },
                  marginBottom: { xs: "80px", md: "0" },
                  marginTop: { xs: "0", md: "80px" }
                }}
                className="func_areas"
                key={element.id}
                onClick={() => {
                  dispatch(clearAllFilters());
                  dispatch(clearSelectedFilters());
                  navigate(`/functionalArea/${element.id}`);
                }}
              >
                <Box
                  className="inside"
                  sx={{ width: { xs: "115px", md: "140px" }, height: { xs: "146px", md: "170px" } }}
                >
                  <Box
                    sx={{
                      display: "block",

                      "&:hover": {
                        backgroundColor: "unset"
                      }
                    }}
                  >
                    <img src={element.media.url} alt="not found" className="func_img" />
                  </Box>
                  <Box sx={{ minHeight: "50px" }}>
                    {" "}
                    <Typography
                      variant={isMobileScreen ? "body2" : "h5"}
                      changeVariant={false}
                      color={element.theme.textColor}
                      showBold
                    >
                      {element.name}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}
        </CardActions>
      </CardContent>
      {!isAdmin && !isAbovePropertyUser && (
        <Grid item container sx={{ justifyContent: "center", alignItems: "center" }}>
          <Typography
            sx={{
              maxWidth: "70%",
              textAlign: "center",
              mb: isMobileScreen ? "24px" : "0"
            }}
            variant={"h5"}
            children={"Would you like to revisit your profile and preferences?"}
          ></Typography>
          <Button
            accessType={accessTypes.delete}
            sx={{ ml: isMobileScreen ? 0 : "24px" }}
            variant="primary"
            label="Retake the Wizard"
            onClick={() => triggerOnboadingWizard(dispatch)}
          />
        </Grid>
      )}
    </Card>
  );
}
